import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';

import PerfectScrollBar from 'react-perfect-scrollbar';

import LenhThuong from '../../components/trading/LenhThuong';
import LenhDieuKien from '../../components/trading/LenhDieuKien';

// import { WebSocketContext } from '../socket/webSocket';
import {
  makeGetToken,
  makeGetDefaultAccount,
  makeGetListAccount,
} from '../../lib/selector';

import { find, isEqual } from 'lodash';
import SaoKeSoLenh from '../../components/trading/SaoKeSoLenh';
import { translate } from 'react-i18next';
import SaoKeLenhDieuKien from '../../components/trading/SaoKeLenhDieuKien';
class Trading extends Component {
  constructor(props) {
    super(props);

    this.state = {
      account: '',
    };
  }

  componentDidMount() {
    const { defaultAccount } = this.props;
    const { account } = this.state;
    if (defaultAccount && !account) {
      this.setState({ account: defaultAccount });
    }
  }

  componentDidUpdate(preProps) {
    const { defaultAccount } = this.props;
    const { account } = this.state;
    if (!isEqual(defaultAccount, preProps.defaultAccount) && !account) {
      this.setState({ account: defaultAccount });
    }
  }

  _setKey = (e) => {
    console.log(e);
    const { listAccount } = this.props;
    console.log(listAccount);
    const _accSel = find(listAccount, (o) => o.value === e);
    if (!_accSel) return;
    this.setState({ account: _accSel });
  };

  render() {
    const {
      match: { params },
      listAccount,
      token,
      t,
    } = this.props;

    const { account } = this.state;

    console.log(params.typeId, account);
    if (!token) return <Redirect to="/" />;
    return (
      <div className="page-asset">
        <Nav as="ul" className="align-items-center asset">
          <Nav.Item as="li" className="ml-4 mr-3">
            <Link
              to="lenh-thuong"
              className={params.typeId === 'lenh-thuong' ? 'active' : ''}
            >
              {t('txt-order-normal')}
            </Link>
          </Nav.Item>
          <Nav.Item as="li" className="mr-3">
            <Link
              to="lenh-dieu-kien"
              className={params.typeId === 'lenh-dieu-kien' ? 'active' : ''}
            >
              {t('txt-order-cond')}
            </Link>
          </Nav.Item>
          <Nav.Item as="li" className="mr-3">
            <Link
              to="sao-ke-so-lenh"
              className={params.typeId === 'sao-ke-so-lenh' ? 'active' : ''}
            >
              {t('txt-label-order-statement')}
            </Link>
          </Nav.Item>
          <Nav.Item as="li" className="mr-3">
            <Link
              to="sao-ke-lenh-dieu-kien"
              className={
                params.typeId === 'sao-ke-lenh-dieu-kien' ? 'active' : ''
              }
            >
              {t('txt-label-order-cond-statement')}
            </Link>
          </Nav.Item>
        </Nav>
        <div className="page-content d-flex flex-row">
          <PerfectScrollBar>
            <Nav
              as="ul"
              className="d-flex flex-column"
              onSelect={(e) => this._setKey(e)}
            >
              <div
                className="d-flex align-items-center fz-14 color-half-brown"
                style={{
                  backgroundColor: '#20222f',
                  height: '57px',
                  borderBottom: '1px solid #535a86',
                }}
              >
                <span className="ml-3 fz-14 text-uppercase">
                  {t('txt-account')}
                </span>
              </div>
              {listAccount &&
                !!listAccount.length &&
                listAccount.map((item, index) => (
                  <Nav.Link
                    key={index}
                    eventKey={item.value}
                    className={account.value === item.value ? 'active' : ''}
                  >
                    {item.label}
                  </Nav.Link>
                ))}
            </Nav>
          </PerfectScrollBar>
          <div
            className="d-flex flex-column"
            style={{ width: 'calc( 100% - 320px )', height: '100%' }}
          >
            {params.typeId === 'lenh-dieu-kien' ? (
              <LenhDieuKien account={account} />
            ) : params.typeId === 'sao-ke-so-lenh' ? (
              <SaoKeSoLenh account={account} />
            ) : params.typeId === 'sao-ke-lenh-dieu-kien' ? (
              <SaoKeLenhDieuKien account={account} />
            ) : (
              <LenhThuong account={account} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

// Trading.contextType = WebSocketContext;

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getListAccount = makeGetListAccount();
  const getDefaultAccount = makeGetDefaultAccount();

  const mapStateToProps = (state, props) => {
    return {
      token: getToken(state),
      defaultAccount: getDefaultAccount(state),
      listAccount: getListAccount(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(translate('translations')(Trading));
